import { Link, useNavigate } from "react-router-dom";
import { useContext, useState } from "react";
import { AuthContext } from "../context/AuthContext";
import { FaUserCircle } from "react-icons/fa";
import "../styles/navbar.css";

export default function Navbar() {
  const { user, token, logout } = useContext(AuthContext);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navigate = useNavigate();

  const isLoggedIn = Boolean(user && token);

  const handleLogout = () => {
    logout();
    navigate("/login");
  };

  return (
    <nav className="navbar transparent">
      <div className="navbar-inner">
        {/* Centered logo */}
        <div className="navbar-logo">
          <Link to="/">
          <img src="/images/logo.png" alt="Onenessence Logo" />
       </Link>
        </div>

        {/* Navigation links below logo */}
        <div className="nav-links">
          <Link to="/">Home</Link>
          <Link to="/about">About</Link>
          <Link to="/services">Services</Link>
          <Link to="/blogs">Blogs</Link>

          {!isLoggedIn && <Link to="/login">Login</Link>}

          {isLoggedIn && (
            <>
              <Link to="/bookings">My Bookings</Link>
              {user.role === "client" && <Link to="/book">Book Session</Link>}
              <div className="user-dropdown" >
                <FaUserCircle
                  size={26}
                  className="user-icon"
                  onClick={() => setDropdownOpen(!dropdownOpen)}
                />
                {dropdownOpen && (
                  <div className="dropdown-menu show">
                    <p><strong>{user.firstName} {user.lastName}</strong></p>
                    <p>Email: {user.emailId}</p>
                    <button onClick={handleLogout} className="logout-btn">
                      Logout
                    </button>
                  </div>
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </nav>
  );
}
